import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import SelectInputWrapper from './select-input-wrapper'
import TextInputWrapper from './text-input-wrapper'
import CheckboxWrapper from './checkbox-wrapper'
import TextAreaWrapper from './text-area-wrapper'
import FlashAlert from '../flash-alert'
import { postForm, patchForm, ajaxDelete } from '../../ajax'

function RegionForm({regionData, countries, states, currencies, onClose, onCreate, onUpdate, onDelete}) {
  const [alert, setAlert] = useState(null)
  const [statesList, setStatesList] = useState(states[regionData.country || 'USA'])
  const { register, setValue, handleSubmit } = useForm({defaultValues: {state: 'Florida'}})
  const isNew = !regionData.id

  useEffect(() => {
    initForm(_.omit(regionData, 'id', 'locations_count'))
  }, [])

  const initForm = (data) => {
    for (const [key, value] of Object.entries(data)) { setValue(key, value) }
  }
  
  const submitUrl = () => {
    if (isNew) 
      return `/admins/regions.json?`
    else
      return `/admins/regions/${regionData.id}.json?`
  }

  const onRemove = () => {
    if (window.confirm('Are you sure you want to remove this region?')) {
      ajaxDelete(`/admins/regions/${regionData.id}`)
      .then(response => {
        if (response.ok) onDelete(regionData)
      })
    }
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) {
      formData.append(`region[${key}]`, data[key]) 
    }
    return formData
  }
  
  const onSubmit = (data) => {
    const formMethod = isNew ? postForm : patchForm
    const formData = prepareFormData(data)

    formMethod(submitUrl(), formData)
    .then(response => { return response.json() })
    .then((json) => {
      if (json.alert)
        setAlert(json.alert)
      else
        isNew ? onCreate(json) : onUpdate(json)
    })
  }

  const onCountryChange = (value) => {
    setValue('country', value)
    const newStatesList = states[value || 'USA']
    setStatesList(newStatesList)
    setValue('state', newStatesList[0])
  }

  return <Modal container={document.body} show={true} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>{isNew ? 'Create Region' : 'Edit Region'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='region-form'>
        { alert && <FlashAlert text={alert.text} type={alert.type} constant centred onHide={() => setAlert(null)} />}
        <form className='form-horizontal' onSubmit={handleSubmit(onSubmit)}>
          <SelectInputWrapper
            {...register('country')}
            label='Country'
            options={countries}
            onChange={e => onCountryChange(e.target.value)}
          />
          <SelectInputWrapper
            {...register('state')}
            label='State'
            options={statesList}
            onChange={(e) => setValue('state', e.target.value)}
          />
          <SelectInputWrapper
            {...register('currency')}
            label='Currency'
            options={currencies}
            onChange={(e) => setValue('currency', e.target.value)}
          />
          <TextInputWrapper
            {...register('name')}
            label='Name'
            placeholder='Region Name'
            onChange={(e) => setValue('name', e.target.value)}
          />
          <div className='region-checkboxes'>
            <div className='region-checkbox-inline'>
              <CheckboxWrapper
                {...register('week_view')}
                label='Week View'
                onChange={(e) => setValue('week_view', e.target.checked)}
              />
              <CheckboxWrapper
                {...register('unexposed')}
                label='Unexposed'
                onChange={(e) => setValue('unexposed', e.target.checked)}
              />
            </div>
            <CheckboxWrapper
              {...register('referral_program_allowed')}
              label='Referral Program'
              onChange={(e) => setValue('referral_program_allowed', e.target.checked)}
            />
            <CheckboxWrapper
              {...register('game_filters')}
              label='Game Filters'
              onChange={(e) => setValue('game_filters', e.target.checked)}
            />
          </div>
          <br />
          <div className='form-group'>
            <div className='col-sm-6 text-left'>
              <input type='submit' value={isNew ? 'Add' : 'Update'} className='btn btn-success' />
            </div>
            { !isNew &&
              <div className='col-sm-6 text-right'>
                <a onClick={onRemove} className='btn btn-danger'>Remove</a>
              </div>
            }
          </div>
        </form>
      </div>
    </Modal.Body>
  </Modal>
}

RegionForm.propTypes = {
  regionData: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default RegionForm
